import { Close } from '@mui/icons-material';
import { Box, Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import { getEmailRecipients } from '../../../../helpers/api';
import { openNotification } from '../../../../helpers/notification';

export default function InvoiceRecipients({ open, onClose, invoiceItem }) {
  const [recipientList, setRecipientList] = useState([]);
  const [recipientLoading, setRecipientLoading] = useState(false);

  // console.log("recipientList",recipientList);

  useEffect(() => {
    fetchRecipientList();
  }, []);

  const fetchRecipientList = async () => {
    setRecipientLoading(true);
    try {
      const res = await getEmailRecipients(
        'FACILITY INVOICE',
        invoiceItem?.facilityId,
        invoiceItem?.invoiceId
      );
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setRecipientList(data);
      } else {
        openNotification({
          status: 'error',
          message: status?.desc,
        });
      }
    } catch (error) {
      openNotification({
        status: 'error',
        message: 'Something went wrong. Please try again',
      });
    } finally {
      setRecipientLoading(false);
    }
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          Invoice Recipients
        </DialogTitle>
        <Box ml="auto" px={3}>
          <IconButton onClick={() => onClose()}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <DialogContent sx={{}}></DialogContent>
    </Dialog>
  );
}
